import { render, staticRenderFns } from "./SuccessCategory.vue?vue&type=template&id=24b48cc0&scoped=true&"
import script from "./SuccessCategory.vue?vue&type=script&lang=js&"
export * from "./SuccessCategory.vue?vue&type=script&lang=js&"
import style0 from "./SuccessCategory.vue?vue&type=style&index=0&id=24b48cc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b48cc0",
  null
  
)

export default component.exports